import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, Outlet, Navigate } from 'react-router-dom';
import Footer from './components/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HomePage from './components/HomePage';
import HvaErNaprapati from './components/HvaErNaprapati';
import OmOss from './components/OmOss';
import Priser from './components/Priser';
import ContactForm from './components/ContactForm';
import BedriftPage from './components/BedriftPage';
import ConditionDetailPage from './components/ConditionDetailPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import Navigation from './components/Navigation';
import NewsListPage from './pages/NewsListPage';
import ScrollToTop from './components/ScrollToTop';
import TagManager from 'react-gtm-module';
import PixelTracker from './components/PixelTracker';
import CookieConsent from 'react-cookie-consent';


// --- NY, GLOBAL AXIOS INTERCEPTOR ---
axios.interceptors.request.use(
  config => {
    // Hent token fra localStorage
    const token = localStorage.getItem('authToken');
    
    // Hvis token finnes, legg den til i 'Authorization'-headeren
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// --- FUNKSJON FOR Å INITIALISERE GTM ---
const initializeGTM = () => {
  const tagManagerArgs = {
    gtmId: 'GT-WKX6929' // Din Tag Manager ID her
  };
  TagManager.initialize(tagManagerArgs);
};

// Hjelpekomponent som legger til Navbar og <main> på alle offentlige sider
const PublicLayout = () => (
  <div className='site-wrapper'>
    <Navigation />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);

// Hjelpekomponent for å beskytte admin-sider
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  return token ? children : <Navigate to="/admin" />;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <PixelTracker />
        <ScrollToTop />
        {/* Denne komponenten håndterer visningen av alle toast-beskjeder */}
        <ToastContainer
          position="top-right"
          autoClose={4000} // Lukkes automatisk etter 4 sekunder
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Routes>
          {/* Alle offentlige sider går gjennom PublicLayout */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/hva-er-naprapati" element={<div className="container"><HvaErNaprapati /></div>} />
            <Route path="/om-oss" element={<div className="container"><OmOss /></div>} />
            <Route path="/priser" element={<div className="container"><Priser /></div>} />
            <Route path="/kontakt" element={<div className="container"><ContactForm /></div>} />
            <Route path="/bedrift" element={<div className="container"><BedriftPage /></div>} />
            <Route path="/tilstander/:slug" element={<div className="container"><ConditionDetailPage /></div>} />
            <Route path="/nyheter" element={<div className="container"><NewsListPage /></div>} />
            <Route path="/nyheter/:slug" element={<div className="container"><ArticleDetailPage /></div>} />
          </Route>
          
          {/* Admin-sider har sin egen, enkle layout */}
          <Route path="/admin" element={<LoginPage />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <PrivateRoute>
                  <main>
                    <div className="admin-page-wrapper">
                      <AdminDashboard />
                    </div>
                  </main>
                  <Footer />
              </PrivateRoute>
            } 
          />
        </Routes>
        {/* --- COOKIE-BANNER --- */}
      <CookieConsent
        location="none"
        cookieName="sunnfjordNaprapatConsentCookie"
        containerClasses="cookie-consent-container"
        contentClasses="cookie-consent-content"
        expires={150}
        enableDeclineButton // Aktiverer "Avslå"-knappen
        declineButtonText="Kun nødvendige"
        declineButtonClasses="button cookie-decline-button" // Egen klasse for styling
        buttonWrapperClasses="cookie-button-wrapper"
        onDecline={() => {
          console.log("Brukeren avslo cookies."); // For din egen info i konsollen
        }}
        buttonText="Aksepter alle"
        buttonClasses="button cookie-consent-button"
        onAccept={() => {
          initializeGTM();
        }}
      >
        Denne nettsiden bruker informasjonskapsler (cookies) for å analysere trafikk og forbedre din brukeropplevelse.
        <div style={{ fontSize: "12px", opacity: "0.8", marginTop: "8px" }}>
          Ved å akseptere, samtykker du til vår bruk av cookies.
        </div>
      </CookieConsent>
      </Router>
    </HelmetProvider>
  );
}

export default App;